import { getString } from "../common/common";

export const BUS_TIME_TABLE = "BUS_TIME_TABLE";
export const BUS_TIME_TABLE_RESULT = "BUS_TIME_TABLE_RESULT";
export const SELECT_STARTING_STATE = "SELECT_STARTING_STATE";
export const SELECT_DESTINATION_STATE = "SELECT_DESTINATION_STATE";
export const ST_STATE = "ST_STATE";
export const ST_CITY = "ST_CITY";
export const DE_STATE = "DE_STATE";
export const DE_CITY = "DE_CITY";
export const VIEW_TIME_TABLE = "VIEW_TIME_TABLE";
export const TIME_TABLE_NOT_PRESENT = "TIME_TABLE_NOT_PRESENT";
export const SEARCH_STARTING_STATE = "SEARCH_STARTING_STATE";
export const SELECT_FROM_STATE_LIST = "SELECT_FROM_STATE_LIST";
export const SEARCH_STARTING_CITY = "SEARCH_STARTING_CITY";
export const SELECT_FROM_CITY_LIST = "SELECT_FROM_CITY_LIST";
export const SEARCH_DESTINATION_STATE = "SEARCH_DESTINATION_STATE";
export const SEARCH_DESTINATION_CITY = "SEARCH_DESTINATION_CITY";
export const FROM = "FROM";
export const TO = "TO";
export const SERVICE_CLASS = "SERVICE_CLASS";
export const VIA_PLACES = "VIA_PLACES";
export const SERVICE_NO = "SERVICE_NO";
export const TIMINGS = "TIMINGS";

export const translations = {
  en: {
    [BUS_TIME_TABLE]: "Bus Time Table Enquiry",
    [BUS_TIME_TABLE_RESULT]: "Bus Time Table Enquiry Results",
    [SELECT_STARTING_STATE]: "Select Starting State !",
    [SELECT_DESTINATION_STATE]: "Select Destination State !",
    [ST_STATE]: "Starting State",
    [ST_CITY]: "Starting City",
    [DE_STATE]: "Destination State",
    [DE_CITY]: "Destination City",
    [VIEW_TIME_TABLE]: "View Time Table",
    [TIME_TABLE_NOT_PRESENT]: "Bus time table not present !",
    [SEARCH_STARTING_STATE]: "Search Starting State",
    [SELECT_FROM_STATE_LIST]: "SELECT FROM STATE LIST",
    [SEARCH_STARTING_CITY]: "Search Starting City",
    [SELECT_FROM_CITY_LIST]: "SELECT FROM CITY LIST",
    [SEARCH_DESTINATION_STATE]: "Search Destination State",
    [SEARCH_DESTINATION_CITY]: "Search Destination City",
    [FROM]: "From",
    [TO]: "To",
    [SERVICE_CLASS]: "Service Class",
    [VIA_PLACES]: "Via Places",
    [SERVICE_NO]: "Service Number",
    [TIMINGS]: "Timings",
  },
  kn: {
    [BUS_TIME_TABLE]: "ಬಸ್ ಟೈಮ್ ಟೇಬಲ್ ವಿಚಾರಣೆ",
    [BUS_TIME_TABLE_RESULT]: "ಬಸ್ ಟೈಮ್ ಟೇಬಲ್ ವಿಚಾರಣೆ ಫಲಿತಾಂಶಗಳು",
    [SELECT_STARTING_STATE]: "ಆರಂಭಿಕ ಸ್ಥಿತಿಯನ್ನು ಆಯ್ಕೆಮಾಡಿ!",
    [SELECT_DESTINATION_STATE]: "ತಲುಪುವ ರಾಜ್ಯವನ್ನು ಆಯ್ಕೆಮಾಡಿ!",
    [ST_STATE]: "ಆರಂಭದ ರಾಜ್ಯ",
    [ST_CITY]: "ಆರಂಭದ ನಗರ",
    [DE_STATE]: "ತಲುಪುವ  ರಾಜ್ಯ",
    [DE_CITY]: "ತಲುಪುವ ನಗರ",
    [VIEW_TIME_TABLE]: "ಟೈಮ್ ಟೇಬಲ್ ನೋಡಿ",
    [TIME_TABLE_NOT_PRESENT]: "ಬಸ್ ಟೈಮ್ ಟೇಬಲ್ ಇಲ್ಲ",
    [SEARCH_STARTING_STATE]: "ಪ್ರಾರಂಭದ ಸ್ಥಿತಿ ಹುಡುಕಿ",
    [SELECT_FROM_STATE_LIST]: "ರಾಜ್ಯದ ಲಿಸ್ಟ್ ಇಂದ ಆಯ್ಕೆಮಾಡಿ",
    [SEARCH_STARTING_CITY]: "ಆರಂಭದ ನಗರವನ್ನು ಹುಡುಕಿ",
    [SELECT_FROM_CITY_LIST]: "ನಗರದ ಲಿಸ್ಟ್ ಇಂದ ಆಯ್ಕೆಮಾಡಿ",
    [SEARCH_DESTINATION_STATE]: "Search Destination State",
    [SEARCH_DESTINATION_CITY]: "ತಲುಪುವ ನಗರವನ್ನು ಹುಡುಕಿ",
    [FROM]: "ನಿಂದ",
    [TO]: "ಇಲ್ಲಿಗೆ",
    [SERVICE_CLASS]: "ಸೇವಾ ವರ್ಗ",
    [VIA_PLACES]: "ಸ್ಥಳಗಳ ಮೂಲಕ",
    [SERVICE_NO]: "ಸೇವಾ ಸಂಖ್ಯೆ",
    [TIMINGS]: "ಸಮಯ",
  },
};

export const t = (key = "") => {
  return getString(key, translations);
};
